import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-959c175a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Countries", -1))
const _hoisted_2 = { class: "ion-no-padding" }
const _hoisted_3 = {
  key: 0,
  class: "load-wrap ion-text-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "ion-padding ion-text-center"
}
const _hoisted_8 = { class: "d-flex ion-align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "pins-count"
}
const _hoisted_10 = {
  key: 1,
  class: "pins-count"
}
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-padding-horizontal white-background-color" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar),
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "fix-heigh" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "ion-no-padding" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_searchbar, {
                value: $data.query,
                onIonChange: _cache[0] || (_cache[0] = ($event: any) => ($data.query = $event.detail.value)),
                class: "ion-margin-top ion-no-padding",
                placeholder: "Search"
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ion_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.filterButton(1))),
                  class: _normalizeClass($data.activeButton == 1 ? 'active' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("A-F")
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_ion_button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.filterButton(2))),
                  class: _normalizeClass($data.activeButton == 2 ? 'active' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("G-M")
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_ion_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.filterButton(3))),
                  class: _normalizeClass($data.activeButton == 3 ? 'active' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("N-Z")
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          ($data.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
            : _createCommentVNode("", true),
          (!$data.isLoading && Object.entries($options.filteredCountries).length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "There are no countries matching your search criteria."))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_list, { class: "ion-margin-top" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries($options.filteredCountries).sort(), (group, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createVNode(_component_ion_item_divider, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-uppercase" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(group[0]), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group[1].sort((a, b) => a.title > b.title ? 1 : -1), (country, i) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: country.id,
                      class: "ion-no-padding",
                      button: "",
                      "detail-icon": $data.caretForwardOutline,
                      lines: i === (group[1].length - 1) ? 'none' : 'full',
                      onClick: ($event: any) => ($options.openCountry(country.id))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "d-flex ion-align-items-center ion-justify-content-between ion-padding-start ion-padding-vertical" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(country.title) + " ", 1),
                            _createElementVNode("div", _hoisted_8, [
                              (_ctx.isLoggedIn)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(country.pins_owned_count + ' / ' + country.pins_total_count), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(country.pins_total_count == 1 ? `${country.pins_total_count} pin` : `${country.pins_total_count} pins`), 1)),
                              _createElementVNode("img", {
                                class: "z-flag ion-padding-start",
                                src: country.flag?.path
                              }, null, 8, _hoisted_11)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["detail-icon", "lines", "onClick"]))
                  }), 128))
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}